import React, { Component } from 'react';
import { DayPickerSingleDateController } from 'react-dates';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { m } from '../../utils';

class DashboardDayPicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: m(),
      focused: false,
    };
  }

  renderDay = (list, day) => {
    const dayBookings = list.filter(dayInList => m(dayInList).isSame(day, 'day'));
    return (
      <div className="single-day">
        <div className="single-day_label">{day.format('D')}</div>
        <div className="single-day_dots">{dayBookings.length ? <span className="single-day_dot">.</span> : null}</div>
      </div>
    );
  };

  render() {
    const { bookings, changeBookingDetail } = this.props;
    const list = bookings.map(booking => booking.date);
    return (
      <div className="dashboard-daypicker">
        <DayPickerSingleDateController
          date={this.state.date}
          focused={this.state.focused}
          enableOutsideDays
          hideKeyboardShortcutsPanel
          noBorder
          renderDayContents={day => this.renderDay(list, day)}
          daySize={45}
          navPrev={<FontAwesomeIcon icon={['fal', 'chevron-left']} />}
          navNext={<FontAwesomeIcon icon={['fal', 'chevron-right']} />}
          firstDayOfWeek={1}
          onFocusChange={focusedInput => this.setState({ ...focusedInput })}
          onDateChange={date => {
            this.setState({ date });
            const _bookings = bookings.filter(booking => m(booking.date).isSame(date, 'day'));
            changeBookingDetail(_bookings);
          }}
          // isDayHighlighted={day1 => list.some(day2 => m(day2).isSame(day1, 'day'))}
        />
      </div>
    );
  }
}

export default DashboardDayPicker;



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardDayPicker.js